import { useCallback, useEffect, useRef } from "react";
import { importScript } from "assets-dynamic-import";
import { addStyle } from "./utils";
import { DEFAULT_GLOBAL_NAME, HIDDEN_BADGE_CSS, getRecaptchaUrl } from "./settings";

const prepareGrecaptcha = grecaptcha =>
	new Promise(resolve => grecaptcha.ready(() => resolve(grecaptcha)));

export default function useGoogleRecaptcha(
	cb,
	{ siteKey, action = "submit", globalName = DEFAULT_GLOBAL_NAME, badgeCss = HIDDEN_BADGE_CSS },
) {
	if (!siteKey) return cb;

	const grecaptchaRef = useRef(null);

	useEffect(() => {
		importScript(getRecaptchaUrl(siteKey), () => global[globalName])
			.then(prepareGrecaptcha)
			.then(grecaptcha => {
				grecaptchaRef.current = grecaptcha;
			});
		if (badgeCss) addStyle(badgeCss);
	}, [siteKey, globalName]);

	const wrappedCb = useCallback(
		(...args) => {
			const grecaptcha = grecaptchaRef.current;
			if (grecaptcha == null) throw new TypeError("grecaptcha is not initialized correctly");
			return grecaptcha.execute(siteKey, { action }).then(token => cb(...args, token));
		},
		[siteKey, cb],
	);

	return wrappedCb;
}
